// src/AppRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ProviderSearchPage from "./ProviderPage/ProviderSearchPage";
import ProviderProfilePage from "./ProviderPage/ProviderProfilePage";
import CreateAlert from "./ProviderPage/CreateAlert";
import JoinWaitlist from "./ProviderPage/components/JoinWaitlist";
import PatientProfile from "./Patient/PatientProfile";
import ProviderProfile from "./Provider/ProviderProfile";
import LoginPage from "./Authentication/LoginPage";
import ForumPage from "./ProviderPage/ForumPage";
import DocumentsTab from "./Patient/DocumentsTab";
import ProviderMatchQuestions from "./ProviderPage/ProviderMatchQuestions";
import PatientCreateAccount from "./Authentication/PatientCreateAccount";
import StatusMessage from "./APIs/StatusMessage";
import AdminTabs from "./AdminUI/AdminTabs";
import AdminRoute from "./AdminUI/AdminRoute";
import ProviderEditProfilePage from "./ProviderPage/ProviderEditProfilePage";
import ProviderMatchesTab from "./Patient/ProviderMatchesTab";
import AvailabilityInfo from "./Provider/AvailabilityInfo";
import ViewAvailabilities from "./Provider/ViewAvailabilities";
import ProviderAppointmentsTab from "./Provider/ProviderAppointmentsTab";
import { PatientAppointmentsTab } from "./Patient/PatientAppointmentsTab";
import AppointmentBooking from "./Patient/AppointmentBooking";
import WaitlistTab from "./Provider/WaitlistTab";
import CreateProviderAlert from "./Provider/CreateProviderAlert";
import EmailProvider from "./Provider/EmailProvider";
import ProviderInformation from "./Provider/ProviderInformation";
import ProviderVerificationPending from "./Provider/ProviderVerificationPending";
import HomePage from "./FeaturePages/HomePage";
import SchedulingFeaturePage from "./FeaturePages/SchedulingFeaturePage";
import MatchingFeaturePage from "./FeaturePages/MatchingFeaturePage";
import AlertsFeaturePage from "./FeaturePages/AlertsFeaturePage";
import CommunicationFeaturePage from "./FeaturePages/CommunicationFeaturePage";
import ReferralCoordinationFeaturePage from "./FeaturePages/ReferralCoordinationFeaturePage";
import ClaimCodePage from "./ExternalReferral/ClaimCodePage";
import ClaimReferralPage from "./ExternalReferral/ClaimReferralPage";
import { useCurrentUser } from "./APIs/UserContext";

const AppRoutes = () => {
  const { currentUser } = useCurrentUser();
  const patientId = currentUser?.patientId || null;
  const providerId = currentUser?.providerId || null;
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/ProviderSearchPage" element={<ProviderSearchPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/ProviderProfile" element={<ProviderProfile />} />
      <Route
        path="/ProviderVerificationPending"
        element={<ProviderVerificationPending />}
      />
      <Route path="/provider/:id" element={<ProviderProfilePage />} />
      <Route
        path="/provider/:id/patient/:patientId"
        element={<ProviderProfilePage />}
      />
      <Route path="/patient/:patientId/profile" element={<PatientProfile />} />
      <Route path="/PatientProfile" element={<PatientProfile />} />
      <Route path="/ForumPage" element={<ForumPage />} />

      <Route path="/CreateAlert" element={<CreateAlert />} />
      <Route path="/JoinWaitlist" element={<JoinWaitlist />} />
      <Route path="/DocumentsTab" element={<DocumentsTab />} />
      <Route
        path="/ProviderMatchQuestions"
        element={<ProviderMatchQuestions patientId={patientId} />}
      />
      <Route path="/PatientCreateAccount" element={<PatientCreateAccount />} />
      <Route path="/status" element={<StatusMessage />} />
      <Route path="/admin" element={<AdminRoute />} />
      <Route path="/AdminTabs" element={<AdminTabs />} />
      <Route
        path="/provider/edit-profile"
        element={<ProviderEditProfilePage />}
      />
      <Route path="/ProviderInformation" element={<ProviderInformation />} />
      <Route
        path="/provider-matches"
        element={<ProviderMatchesTab patientId={patientId} />}
      />
      <Route
        path="/book/availability/:providerId/:zdt"
        element={<AvailabilityInfo />}
      />
      <Route
        path="/book/availability/:providerId/id/:availabilityId"
        element={<AvailabilityInfo />}
      />
      <Route
        path="/provider/:providerId/availabilities"
        element={<ViewAvailabilities />}
      />
      <Route
        path="/provider/:providerId/appointments"
        element={<ProviderAppointmentsTab />}
      />
      <Route
        path="/patient/:patientId/appointments"
        element={<PatientAppointmentsTab />}
      />
      <Route
        path="/book/appointment/:providerId/:patientId"
        element={<AppointmentBooking patientId={patientId} />}
      />
      <Route
        path="/waitlist/join/:providerId/:patientId"
        element={<JoinWaitlist patientId={patientId} />}
      />
      <Route
        path="/waitlist/providers/:providerId"
        element={<WaitlistTab providerId={providerId} />}
      />
      <Route
        path="/waitlist/providers/:providerId/appointments"
        element={<WaitlistTab />}
      />
      <Route path="/EmailProvider" element={<EmailProvider />} />
      <Route path="/CreateProviderAlert" element={<CreateProviderAlert />} />
      <Route path="/features/scheduling" element={<SchedulingFeaturePage />} />
      <Route path="/features/matching" element={<MatchingFeaturePage />} />
      <Route path="/features/alerts" element={<AlertsFeaturePage />} />
      <Route
        path="/features/communication"
        element={<CommunicationFeaturePage />}
      />
      <Route
        path="/features/referral"
        element={<ReferralCoordinationFeaturePage />}
      />
      <Route path="/home" element={<HomePage />} />

      {/* Public external referral claim routes — no auth required */}
      <Route path="/claim" element={<ClaimCodePage />} />
      <Route path="/claim-referral" element={<ClaimReferralPage />} />
    </Routes>
  );
};

export default AppRoutes;
